export default "__VITE_ASSET__BL5zM0UJ__"